import { useState } from "react";
import { AiOutlineDown } from "react-icons/ai";
import styles from "./GenerateKit.module.css";

const formatPrice = (n) =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format(n ?? 0);

const getPriceTier = (price, productSplit) => {
  if (!productSplit || price == null) return null;
  const p = Number(price);
  if (p <= productSplit.low?.max) return "Low";
  if (p <= productSplit.medium?.max) return "Medium";
  return "High";
};

export const KitProductItem = ({ product, kitIndex, productSplit, onReplace }) => {
  const [replacementsOpen, setReplacementsOpen] = useState(false);
  const hasReplacements = product.replacements?.length > 0;
  const tier = getPriceTier(product.price, productSplit);

  return (
    <div className={styles.kitProductItem}>
      <div className={styles.kitProductMain}>
        <div className={styles.kitProductImageWrapper}>
          {product.image ? (
            <img
              src={product.image}
              alt={product.name}
              className={styles.kitProductImage}
            />
          ) : (
            <div className={styles.kitProductImagePlaceholder} />
          )}
        </div>
        <div className={styles.kitProductInfo}>
          <div className={styles.kitProductName}>{product.name}</div>
          <div className={styles.kitProductMetaRow}>
            {product.brandName && (
              <span className={styles.kitProductMeta}>{product.brandName}</span>
            )}
            {tier && (
              <span
                className={`${styles.kitProductTierChip} ${
                  styles[`kitProductTierChip${tier}`]
                }`}
              >
                {tier}
              </span>
            )}
          </div>
        </div>
        <div className={styles.kitProductRight}>
          <div className={styles.kitProductPriceQty}>
            <span className={styles.kitProductPrice}>
              {formatPrice(product.price)}
            </span>
            <span className={styles.kitProductQty}>
              Qty: {product.quantity ?? 1}
            </span>
          </div>
          {hasReplacements && (
            <button
              type="button"
              className={styles.kitProductExpandBtn}
              onClick={() => setReplacementsOpen((o) => !o)}
              aria-expanded={replacementsOpen}
            >
              <AiOutlineDown
                className={`${styles.kitProductExpandIcon} ${
                  replacementsOpen ? styles.open : ""
                }`}
              />
            </button>
          )}
        </div>
      </div>

      {hasReplacements && replacementsOpen && (
        <div className={styles.kitReplacements}>
          <div className={styles.kitReplacementsHeader}>
            REPLACEMENT OPTIONS
          </div>
          <div className={styles.kitReplacementsList}>
            {product.replacements.map((replacement) => (
              <div
                key={replacement.productId}
                className={styles.kitReplacementItem}
              >
                <div className={styles.kitReplacementImageWrapper}>
                  {replacement.image ? (
                    <img
                      src={replacement.image}
                      alt={replacement.name}
                      className={styles.kitProductImage}
                    />
                  ) : (
                    <div className={styles.kitProductImagePlaceholder} />
                  )}
                </div>
                <div className={styles.kitReplacementInfo}>
                  <span className={styles.kitReplacementName}>
                    {replacement.name}
                  </span>
                  <span className={styles.kitReplacementPrice}>
                    {formatPrice(replacement.price)}
                  </span>
                </div>
                <button
                  type="button"
                  className={styles.kitReplaceButton}
                  onClick={() =>
                    onReplace?.(kitIndex, product.productId, replacement)
                  }
                >
                  Replace
                </button>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
